import { CheckboxWithHelperText, FlexColumn, FlexRow, Message, SingleSelect, Text, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCareAndCompositionSubtypeStore } from "./CareAndCompositionSubtypeStore";
import { red } from "designSystem/styles/color";

interface CareAndCompositionSubtypeMainContentProps { }

const CareAndCompositionSubtypeMainContent: FunctionComponent<CareAndCompositionSubtypeMainContentProps> = observer(function CareAndCompositionSubtypeMainContent(props) {
	const {
		allowMaterialCompositionEdits,
		allowZeroPercentEntries,
		enableParentChildPlacements,
		enforce100PercentPerPlacement,
		languageSyntax,
		languageSyntaxOptions,
		setAllowMaterialCompositionEdits,
		setAllowZeroPercentEntries,
		setEnableParentChildPlacements,
		setEnforce100PercentPerPlacement,
		setLanguageSyntax,
		setName,
		subtypeName,
		subtypeExistsError,
	} = useCareAndCompositionSubtypeStore();

	return (
		<FlexColumn
			gap={4}
			paddingBottom={4}
		>
			<FlexColumn gap={1}>
				<FlexRow alignItems="center">
					<Text
						bold
						res="CareAndCompositionDataSheetType"
						size={12}
					/>
					<Text 
						color="red"
						paddingLeft={1}
						size={12}
						text="*"
					/>
				</FlexRow>
				<TextField
					error={subtypeExistsError}
					helperTextRes={subtypeExistsError ? "ValidateUniqueNodeName" : undefined}
					onChange={setName}
					placeholderRes="CareAndCompositionDataSheetType"
					type="string"
					value={subtypeName}
				/>
			</FlexColumn>
			<FlexColumn gap={2}>
				<FlexColumn gap={1}>
					<Text
						bold
						res="CareAndCompositionDataSheet_CompositionSettings"
						size={12}
					/>
					<CheckboxWithHelperText 
						helperTextRes="Enforce100PercentPerPlacement_HelperText"
						isChecked={enforce100PercentPerPlacement}
						mainTextSemiBold
						onChange={setEnforce100PercentPerPlacement}
						res="Enforce100PercentPerPlacement"
					/>
					<CheckboxWithHelperText 
						helperTextRes="AllowZeroPercentEntries_HelperText"
						isChecked={allowZeroPercentEntries}
						mainTextSemiBold
						onChange={setAllowZeroPercentEntries}
						res="AllowZeroPercentEntries"
					/>
					<CheckboxWithHelperText 
						helperTextRes="AllowMaterialCompositionEdits_HelperText"
						isChecked={allowMaterialCompositionEdits}
						mainTextSemiBold
						onChange={setAllowMaterialCompositionEdits}
						res="AllowMaterialCompositionEdits"
					/>
					{/*
					TODO: This will come with the new feature for multi level placements
					<CheckboxWithHelperText 
						helperTextRes="EnableParentChildPlacements_HelperText"
						isChecked={enableParentChildPlacements}
						mainTextSemiBold
						onChange={setEnableParentChildPlacements}
						res="EnableParentChildPlacements"
					/> */}
				</FlexColumn>
				<FlexColumn gap={1}>
					<FlexRow alignItems="center">
						<Text
							bold
							res="LanguageSyntax"
							size={12}
						/>
						<Text 
							color="red"
							paddingLeft={1}
							size={12}
							text="*"
						/>
					</FlexRow>
					<SingleSelect
						disableClearable
						fullWidth
						helperTextRes="LanguageSyntax_HelperText"
						onChange={setLanguageSyntax}
						options={languageSyntaxOptions}
						placeHolderRes="SelectLanguageSyntax"
						value={languageSyntax}
					/>
				</FlexColumn>
			</FlexColumn>
		</FlexColumn>
	);
},
);

export default CareAndCompositionSubtypeMainContent;